import { CATEGORY_ICONS, CATEGORY_LABELS } from "@/lib/categories";

export default function CategoryChip({ slug, active, onClick, count }) {
    const Icon = CATEGORY_ICONS[slug];
    return (
        <button
            data-testid={`category-chip-${slug}`}
            onClick={onClick}
            className={`inline-flex items-center gap-2 px-4 py-2 border transition-colors font-oswald uppercase tracking-wider text-xs whitespace-nowrap ${
                active
                    ? "bg-volt text-black border-volt"
                    : "bg-transparent text-[#94a3b8] border-white/15 hover:border-volt hover:text-white"
            }`}
        >
            {Icon && <Icon className="w-3.5 h-3.5" />}
            <span>{CATEGORY_LABELS[slug] || slug}</span>
            {count != null && (
                <span className={`mono-label ml-1 ${active ? "text-black/70" : "text-volt"}`}>
                    {String(count).padStart(2, "0")}
                </span>
            )}
        </button>
    );
}
